import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

var emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var mobileRegexp = /^07\d{8}$/;
var dialogRegex =  /^(077|076)\d{7}$/;
var dialogEtisalatHutchRegex =  /^(077|076|078|072)\d{7}$/;
var mobitelRegex =  /^(071|070)\d{7}$/;
var lankabellRegex =  /^\d{16}$/;
var cardExpireDateregex = /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;
var cvvRegex = /^[0-9]{3}$/;
var cardNumberRegex = /^[0-9]{6,}$/;

export function emailValidator(control: FormControl): { [key: string]: any } {
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
}

export function dialogValidator(control: FormControl): { [key: string]: any } {
  if (control.value && !dialogRegex.test(control.value)) {
    return { 'isDialog': true };
  }
}

export function cardExpireDate(control: FormControl): { [key: string]: any } {
  if (control.value && !cardExpireDateregex.test(control.value)) {
    return { 'isExpire': true };
  }
}

export function cvv(control: FormControl): { [key: string]: any } {
  if (control.value && !cvvRegex.test(control.value)) {
    return { 'isCvv': true };
  }
}

export function cardNumber(control: FormControl): { [key: string]: any } {
  if (control.value && !cardNumberRegex.test(control.value)) {
    return { 'validCard': true };
  }
}

export function dialogEtisalatHutchValidator(control: FormControl): { [key: string]: any } {
  if (control.value && !dialogEtisalatHutchRegex.test(control.value)) {
    return { 'isDialog': true };
  }
}

export function mobitelValidator(control: FormControl): { [key: string]: any } {
  if (control.value && !mobitelRegex.test(control.value)) {
    return { isMobitel: true };
  }
}

export function lankaBellvalidator(control: FormControl): { [key: string]: any } {
  if (control.value && !lankabellRegex.test(control.value)) {
    return { isMobitel: true };
  }
}

export function emptyField(control: FormControl): { [key: string]: any } {
  var spaceRegex = /^\s+/;
  let isWhitespace = (control.value || '').trim().length != 0 && !spaceRegex.test(control.value);
  let isValid = !isWhitespace;
  return isWhitespace ? null : { 'whitespace': true }
}

export function isValidEmail(input) {
  if (input && !emailRegexp.test(input)) {
    return true;
  } else {
    return false;
  }
}

export function isValidEmailOrMobile(input) {
  if (!emailRegexp.test(input)) {
    if (!mobileRegexp.test(input)) {
      return true;
    }
    return null
  }
  return null;
}

//Phone number validation
export function mobileValidator(control: FormControl): { [key: string]: any } {

  // For all mobile numbers
  if (control.value && !mobileRegexp.test(control.value)) {
    return { invalidMobile: true };
  }
  // Only for dialog mobile numbers
  // if (control.value && !dialogRegex.test(control.value)) {
  //   return { invalidMobile: true };
  // }
}

//mobile and email
export function usernameValidator(control: FormControl): { [key: string]: any } {
  var mobileRegexp = /^07\d{8}$/;
  if (!emailRegexp.test(control.value)) {
    if (!mobileRegexp.test(control.value)) {
      return { isError: true };
    }
  }
}

// FORM GROUP VALIDATORS
export function matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
  return (group: FormGroup): { [key: string]: any } => {
    let password = group.controls[passwordKey];
    let confirmPassword = group.controls[confirmPasswordKey];

    if (password.value !== confirmPassword.value) {
      return {
        mismatchedPasswords: true
      };
    }
  }
}

export function mobileNumberValidator(key, type): boolean {
   let mobitel = /^(071|070)\d{7}$/, dialog = /^(077|076)\d{7}$/;
  if ((type == 1 ? mobitel : dialog ).test(key)) {
    return true;
  }
  return false;

}

export function getCardType(number: any){
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null)
        return "/assets/img/visa.png";

    // Mastercard
    re = new RegExp("^5[1-5]");
    if (number.match(re) != null)
        return "/assets/img/master.png";

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null)
        return "/assets/img/amex.png";

    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null)
        return "/assets/img/discover.png";

    // Diners
    re = new RegExp("^36");
    if (number.match(re) != null)
        return "/assets/img/diners.png";

    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null)
        return "/assets/img/diners.png";

    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null)
        return "/assets/img/jcb.png";

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null)
        return "/assets/img/visa-electron.png";

    return "";
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/validator.ts